export const updateStateArray=async(oldArray,newArray,setArray)=>{
    let data=oldArray;
    newArray.map((user)=>{
      let find=oldArray.findIndex(emp => emp.id === user.id);
      if(find==-1){
        data.push(user);
      }
    })
    setArray(data);
  }